//SIDEBAR SLIDER
export const OPEN_SLIDER = "OPEN_SLIDER";
export const CLOSE_SLIDER = "CLOSE_SLIDER";
export const SELECTED_MENU_ITEM = "SELECTED_MENU_ITEM";

//HEADER BUTTON
export const SET_HEADER_BUTTON_PARAMS = "SET_HEADER_BUTTON_PARAMS";
export const SET_HEADER_TEXT = "SET_HEADER_TEXT";
export const SET_HEADER_ADVANCED_SEARCH_PARAMS = "SET_HEADER_ADVANCED_SEARCH_PARAMS";

//COURSES MODULE
export const COURSES_IS_LOADING = "COURSES_IS_LOADING";
export const COURSES_LOAD_SUCCESS = "COURSES_LOAD_SUCCESS";
export const COURSES_LOAD_ERROR = "COURSES_LOAD_ERROR";
export const COURSES_INTEGRITY_ERROR = "COURSES_INTEGRITY_ERROR";
export const RESET_INTERGRITY_ERROR = "RESET_INTERGRITY_ERROR";

//COMMON FORM ACTIONS
export const IS_SUBMITTING = "IS_SUBMITTING";
export const SUBMIT_SUCCESS = "SUBMIT_SUCCESS";
export const SUBMIT_ERROR = "SUBMIT_ERROR";
export const RESET_FORM_STATUS = "RESET_FORM_STATUS";
export const IS_UPDATING = "IS_UPDATING";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_ERROR = "UPDATE_ERROR";

//QUESTIONS FORM ACTIONS
export const IS_SUBMITTING_QUESTIONS = "IS_SUBMITTING_QUESTIONS";
export const SUBMIT_QUESTIONS_SUCCESS = "SUBMIT_QUESTIONS_SUCCESS";
export const SUBMIT_QUESTIONS_ERROR = "SUBMIT_QUESTIONS_ERROR";
export const RESET_QUESTIONS_FORM_STATUS = "REST_QUESTIONS_FORM_STATUS";

//EDIT FORM ACTIONS
export const SET_EDIT = "SET_EDIT";
export const RESET_EDIT = "RESET_EDIT";

//SETTINGS MODULE
export const SETTINGS_IS_LOADING = "SETTINGS_IS_LOADING";
export const SETTINGS_LOAD_SUCCESS = "SETTINGS_LOAD_SUCCESS";
export const SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR";

//QUIZZES MODULE
export const QUIZZES_IS_LOADING = "QUIZZES_IS_LOADING";
export const QUIZZES_LOAD_SUCCESS = "QUIZZES_LOAD_SUCCESS";
export const QUIZZES_LOAD_ERROR = "QUIZZES_LOAD_ERROR";
export const RESET_QUIZZES_DATA = "RESET_QUIZZES_DATA";
export const QUIZ_CREATED = "QUIZ_CREATED";

//LOAD QUESTIONS FOR EDITING
export const IS_LOADING = "IS_LOADING";
export const LOAD_SUCCESS = "LOAD_SUCCESS";
export const LOAD_ERROR = "LOAD_ERROR";
export const RESET_LOADED_QUESTIONS = "RESET_LOADED_QUESTIONS";

// ANNOUNCEMENTS MODULE
export const ANNOUNCEMENTS_IS_LOADING = "ANNOUNCEMENTS_IS_LOADING";
export const ANNOUNCEMENTS_LOAD_SUCCESS = "ANNOUNCEMENTS_LOAD_SUCCESS";
export const ANNOUNCEMENTS_LOAD_ERROR = "ANNOUNCEMENTS_LOAD_ERROR";

// STATISTICS - DASHBOARD MODULE
export const STATISTICS_IS_LOADING = "STATISTICS_IS_LOADING";
export const STATISTICS_LOAD_SUCCESS = "STATISTICS_LOAD_SUCCESS";
export const STATISTICS_LOAD_ERROR = "STATISTICS_LOAD_ERROR";

// LEADERSHIP BOARD - DASHBOARD MODULE
export const LEADERSHIP_BOARD_IS_LOADING = "LEADERSHIP_BOARD_IS_LOADING";
export const LEADERSHIP_BOARD_LOAD_SUCCESS = "LEADERSHIP_BOARD_LOAD_SUCCESS";
export const LEADERSHIP_BOARD_LOAD_ERROR = "LEADERSHIP_BOARD_LOAD_ERROR";

// REPORTS MODULE
export const REPORTS_IS_LOADING = "REPORTS_IS_LOADING";
export const REPORTS_LOAD_SUCCESS = "REPORTS_LOAD_SUCCESS";
export const REPORTS_LOAD_ERROR = "REPORTS_LOAD_ERROR";

//SELECTED COURSE
export const SELECTED_COURSE_IS_LOADING = 'SELECTED_COURSE_IS_LOADING';
export const SELECTED_COURSE_LOAD_SUCCESS = 'SELECTED_COURSE_LOAD_SUCCESS';
export const SELECTED_COURSE_LOAD_ERROR = 'SELECTED_COURSE_LOAD_ERROR';
export const RESET_SELECTED_COURSE = 'RESET_SELECTED_COURSE';

//SEARCH FUNCTION AUTOCOMPLETE
export const SEARCH_AUTOCOMPLETE_LIST_LOADING = 'SEARCH_AUTOCOMPLETE_LIST_LOADING';
export const SEARCH_QUERY_LOADING = "SEARCH_QUERY_LOADING";
export const SEARCH_COMPONENT_RESET = "SEARCH_COMPONENT_RESET";
export const SEARCH_FINAL_QUERY = "SEARCH_FINAL_QUERY";
export const SET_AUTOCOMPLETE_VISIBILITY = "SET_AUTOCOMPLETE_VISIBILITY";

//SELECTED VIEW IN COURSE
export const CURRENT_VIEW = 'CURRENT_VIEW';
export const RESET_VIEW = 'RESET_VIEW';

//ADVANCED SEARCH
export const SET_ADVANCED_SEARCH = 'SET_ADVANCED_SEARCH';
export const RESET_ADVANCED_SEARCH = 'RESET_ADVANCED_SEARCH';

//COMMENTS
export const COMMENTS_IS_LOADING = "COMMENTS_IS_LOADING";
export const COMMENTS_LOAD_SUCCESS = "COMMENTS_LOAD_SUCCESS";
export const COMMENTS_LOAD_ERROR = "COMMENTS_LOAD_ERROR";
export const COMMENTS_RESET = "COMMENTS_RESET";

// COURSE LEADERSHIP BOARD - COURSE DASHBOARD MODULE
export const COURSE_LEADERSHIP_BOARD_IS_LOADING = "COURSE_LEADERSHIP_BOARD_IS_LOADING";
export const COURSE_LEADERSHIP_BOARD_LOAD_SUCCESS = "COURSE_LEADERSHIP_BOARD_LOAD_SUCCESS";
export const COURSE_LEADERSHIP_BOARD_LOAD_ERROR = "COURSE_LEADERSHIP_BOARD_LOAD_ERROR";


//LOAD SCHEDULE
export const SCHEDULE_IS_LOADING = "SCHEDULE_IS_LOADING";
export const SCHEDULE_LOAD_SUCCESS = "SCHEDULE_LOAD_SUCCESS";
export const SCHEDULE_LOAD_ERROR = "SCHEDULE_LOAD_ERROR";
export const RESET_SCHEDULE_DATA = "RESET_SCHEDULE_DATA"

//CALENDAR MONTH
export const MONTH_IS_LOADING = "MONTH_IS_LOADING";
export const MONTH_LOAD_SUCCESS = "MONTH_LOAD_SUCCESS";
export const MONTH_LOAD_ERROR = "MONTH_LOAD_ERROR";

//LOAD CLASSES
export const CLASSES_IS_LOADING = "CLASSES_IS_LOADING";
export const CLASSES_LOAD_SUCCESS = "CLASSES_LOAD_SUCCESS";
export const CLASSES_LOAD_ERROR = "CLASSES_LOAD_ERROR";

//LOAD CATEGORIES
export const CATEGORIES_IS_LOADING = "CATEGORIES_IS_LOADING";
export const CATEGORIES_LOAD_SUCCESS = "CATEGORIES_LOAD_SUCCESS";
export const CATEGORIES_LOAD_ERROR = "CATEGORIES_LOAD_ERROR";


//LOAD CATEGORY_ITEMS
export const CATEGORY_ITEMS_IS_LOADING = "CATEGORY_ITEMS_IS_LOADING";
export const CATEGORY_ITEMS_LOAD_SUCCESS = "CATEGORY_ITEMS_LOAD_SUCCESS";
export const CATEGORY_ITEMS_LOAD_ERROR = "CATEGORY_ITEMS_LOAD_ERROR";
export const CATEGORY_ITEMS_RESET = "CATEGORY_ITEMS_RESET";

//SELECTED ID FOR MANAGE CLASSES
export const SET_SELECTED_SCHEDULE_ID = "SET_SELECTED_SCHEDULE_ID"
export const RESET_SELECTED_SCHEDULE_ID = "RESET_SELECTED_SCHEDULE_ID"

//LIVE COURSES MODULE
export const LIVE_COURSES_IS_LOADING = "LIVE_COURSES_IS_LOADING";
export const LIVE_COURSES_LOAD_SUCCESS = "LIVE_COURSES_LOAD_SUCCESS";
export const LIVE_COURSES_LOAD_ERROR = "LIVE_COURSES_LOAD_ERROR";

//ACCESS_TOKEN LIVE SESSIONS
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const RESET_ACCESS_TOKEN = "RESET_ACCESS_TOKEN";

// REGISTRATION_SUBJECTS 
export const GET_REGISTRATION_SUBJECTS = "GET_REGISTRATION_SUBJECTS";
export const REGISTRATION_SUBJECTS_SUCCESS = "REGISTRATION_SUBJECTS_SUCCESS";
export const REGISTRATION_SUBJECTS_FAIL = "REGISTRATION_SUBJECTS_FAIL";

// LIVE_SUBJECTS 
export const GET_LIVE_SUBJECTS = "GET_LIVE_SUBJECTS";
export const LIVE_SUBJECTS_SUCCESS = "LIVE_SUBJECTS_SUCCESS";
export const LIVE_SUBJECTS_FAIL = "LIVE_SUBJECTS_FAIL";

//EXAM LOAD SCHEDULE
export const EXAM_SCHEDULE_IS_LOADING = "EXAM_SCHEDULE_IS_LOADING";
export const EXAM_SCHEDULE_LOAD_SUCCESS = "EXAM_SCHEDULE_LOAD_SUCCESS";
export const EXAM_SCHEDULE_LOAD_ERROR = "EXAM_SCHEDULE_LOAD_ERROR";
export const EXAM_RESET_SCHEDULE_DATA = "EXAM_RESET_SCHEDULE_DATA"


//EXAM LOAD SCHEDULE
export const EXAM_ANSWER_SHEET_IS_LOADING = "EXAM_ANSWER_SHEET_IS_LOADING";
export const EXAM_ANSWER_SHEET_LOAD_SUCCESS = "EXAM_ANSWER_SHEET_LOAD_SUCCESS";
export const EXAM_ANSWER_SHEET_LOAD_ERROR = "EXAM_ANSWER_SHEET_LOAD_ERROR";
export const EXAM_ANSWER_SHEET_RESET_DATA = "EXAM_ANSWER_SHEET_RESET_DATA"


/****Analytics***********/


//Load Student List

export const REPORTS_STUDENT_LIST_IS_LOADING = "REPORTS_STUDENT_LIST_IS_LOADING";
export const REPORTS_STUDENT_LIST_LOAD_SUCCESS = "REPORTS_STUDENT_LIST_LOAD_SUCCESS";
export const REPORTS_STUDENT_LIST_LOAD_ERROR = "REPORTS_STUDENT_LIST_LOAD_ERROR";

//Load Tutor Subjects List

export const TUTOR_SUBJECTS_IS_LOADING = "TUTOR_SUBJECTS_IS_LOADING";
export const TUTOR_SUBJECTS_LOAD_SUCCESS = "TUTOR_SUBJECTS_LOAD_SUCCESS";
export const TUTOR_SUBJECTS_LOAD_ERROR = "TUTOR_SUBJECTS_LOAD_ERROR";


//Load Tutor Subject Exam Schedules List

export const TUTOR_SUBJECT_EXAM_SCHEDULE_IS_LOADING = "TUTOR_SUBJECT_EXAM_SCHEDULE_IS_LOADING";
export const TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_SUCCESS = "TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_SUCCESS";
export const TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_ERROR = "TUTOR_SUBJECT_EXAM_SCHEDULE_LOAD_ERROR";


//Load  Exam Schedules Student List

export const EXAM_SCHEDULE_STUDENT_IS_LOADING = "EXAM_SCHEDULE_STUDENT_IS_LOADING";
export const EXAM_SCHEDULE_STUDENT_LOAD_SUCCESS = "EXAM_SCHEDULE_STUDENT_LOAD_SUCCESS";
export const EXAM_SCHEDULE_STUDENT_LOAD_ERROR = "EXAM_SCHEDULE_STUDENT_LOAD_ERROR";
